module.exports = __webpack_public_path__ + "static/img/YE.8445385b.png";